import { render, staticRenderFns } from "./PriceRuleItem.vue?vue&type=template&id=47912f1a&"
import script from "./PriceRuleItem.vue?vue&type=script&lang=js&"
export * from "./PriceRuleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports